import { render, staticRenderFns } from "./EasyPageTemplate.vue?vue&type=template&id=488e61ae&scoped=true&"
import script from "./EasyPageTemplate.vue?vue&type=script&lang=js&"
export * from "./EasyPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EasyPageTemplate.vue?vue&type=style&index=0&id=488e61ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e61ae",
  null
  
)

export default component.exports